import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'wfdss-approve-decision-modal',
    templateUrl: './approve-decision-modal.component.html',
    styleUrls: ['./approve-decision-modal.component.scss'],
    standalone: false
})
export class ApproveDecisionModalComponent implements OnInit {

  modalMessage = '';

  constructor(public dialogRef: MatDialogRef<ApproveDecisionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data) { }

  ngOnInit() {
  }

  onClose(buttonName: string) {
    this.dialogRef.close(buttonName);
  }
}
